import { BalancesV2 } from '@src/containers/Blotters/BalancesV2';
import type { BalancesBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function BalancesPanel({ params, api }: LayoutPanelProps<BalancesBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.BalancesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="balances-blotter-panel"
      >
        <BalancesV2 />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
